/* SET STATE */
export const SET_STATE_LABREQUESTSURVEY = "SET_STATE_LABREQUESTSURVEY"

/* LABREQUESTSURVEYS */
export const GET_LABREQUESTSURVEYS = "GET_LABREQUESTSURVEYS"
export const GET_LABREQUESTSURVEYS_SUCCESS = "GET_LABREQUESTSURVEYS_SUCCESS"
export const GET_LABREQUESTSURVEYS_FAIL = "GET_LABREQUESTSURVEYS_FAIL"

/* LABREQUESTSURVEYS */
export const GET_LABREQUESTSURVEYSCALCULATE = "GET_LABREQUESTSURVEYSCALCULATE"
export const GET_LABREQUESTSURVEYSCALCULATE_SUCCESS = "GET_LABREQUESTSURVEYSCALCULATE_SUCCESS"
export const GET_LABREQUESTSURVEYSCALCULATE_FAIL = "GET_LABREQUESTSURVEYSCALCULATE_FAIL"

/* LABREQUESTSURVEY */
export const GET_LABREQUESTSURVEY = "GET_LABREQUESTSURVEY"
export const GET_LABREQUESTSURVEY_SUCCESS = "GET_LABREQUESTSURVEY_SUCCESS"
export const GET_LABREQUESTSURVEY_FAIL = "GET_LABREQUESTSURVEY_FAIL"

/**
 * ADD LABREQUESTSURVEY
 */
 export const ADD_NEW_LABREQUESTSURVEY = "ADD_NEW_LABREQUESTSURVEY"
 export const ADD_LABREQUESTSURVEY_SUCCESS = "ADD_LABREQUESTSURVEY_SUCCESS"
 export const ADD_LABREQUESTSURVEY_FAIL = "ADD_LABREQUESTSURVEY_FAIL"

 /**
 * UPDATE LABREQUESTSURVEY
 */
export const UPDATE_LABREQUESTSURVEY = "UPDATE_LABREQUESTSURVEY"
export const UPDATE_LABREQUESTSURVEY_SUCCESS = "UPDATE_LABREQUESTSURVEY_SUCCESS"
export const UPDATE_LABREQUESTSURVEY_FAIL = "UPDATE_LABREQUESTSURVEY_FAIL"

/**
 * DELETE LABREQUESTSURVEY
 */
export const DELETE_LABREQUESTSURVEY = "DELETE_LABREQUESTSURVEY"
export const DELETE_LABREQUESTSURVEY_SUCCESS = "DELETE_LABREQUESTSURVEY_SUCCESS"
export const DELETE_LABREQUESTSURVEY_FAIL = "DELETE_LABREQUESTSURVEY_FAIL"
